import { Button } from "flowbite-react";
import React, { useState } from "react";
import SubscriptionHistoryWidget from "./SubscriptionHistoryWidget";
import { subscriptions } from "../../../state/useSubscriptionStore";
import CancelSubscriptionPrompt from "./cancelSubscriptionPrompt";
import { SidebarDrawer } from "../../common";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { formatMoney } from "../../../utils";
import { useTranslation } from "react-i18next";
import SubscriptionPage from "../../../pages/Subscription";
import UsageIndicator from "./UsageIndicator";
import { Active } from "../../../constants/Subscription";

interface SubscriptionPlanProps {
  subscriptionState: subscriptions | null;
  showPrompt: boolean;
  setShowPrompt: (value: boolean) => void;
}

const SubscriptionPlan = ({ subscriptionState, setShowPrompt }: SubscriptionPlanProps) => {

  const { t } = useTranslation("subscription");

 

  const [showModal, setShowModal] = useState(false); // State to control modal visibility

  const expirationDate = subscriptionState?.daysTotal && subscriptionState?.daysUsed !== undefined
  ? dayjs().add(subscriptionState.daysTotal - subscriptionState.daysUsed, 'day').format("MMM D, YYYY")
  : "N/A";


  
  const getDaySuffix = (day: number) => {
    if (day >= 11 && day <= 13) {
      return day + "th";
    }

    switch (day % 10) {
      case 1:
        return day + "st";
      case 2:
        return day + "nd";
      case 3:
        return day + "rd";
      default:
        return day + "th";
    }
  };

  const formattedDate = subscriptionState
    ? t("subscription.nextDate", {
        month: dayjs(subscriptionState?.endDate).format("MMM"),
        day: getDaySuffix(dayjs(subscriptionState?.endDate).date()),
        year: dayjs(subscriptionState?.endDate).format("YYYY"),
      })
    : t("subscription.expiredMessage");
  return (
    <>
    <div className="w-full lg:w-[105.4%]">
      <p className="text-[14px] sm:text-[16px] whitespace-nowrap">
        {/* {formattedDate} */}
        {/* {subscriptionState
          ? `Your Next Subscription Plan Date is 
     ${dayjs(subscriptionState?.endDate).format('MMM')} 
     ${getDaySuffix(dayjs(subscriptionState?.endDate).date())} 
     ${dayjs(subscriptionState?.endDate).format('YYYY')}`
          : "You don't have an active subscription"} */}
      </p>{" "}
      <div className="borderrounded-[4px] w-full border md:flex gap-[30px] pb-[21px] flex-col justify-between  rounded-lg pt-[16.5px] mt-[12px] hidden">
        <div className="flex flex-col justify-start items-start md:px-[30px] px-[12px]">
          {subscriptionState?.status == "pending" ? (
            <SkeletonTheme baseColor="#BDD0DB" highlightColor="#fff">
              <Skeleton style={{ width: 70 }} height={"18px"} />
            </SkeletonTheme>
          ) : (
            <div className="flex w-full justify-between items-center">
            <p
              className="text-[#212121] capitalize text-[20px] "
              style={{ fontWeight: 600 }}
            >
              {subscriptionState?.plan
                ? subscriptionState.plan
                : "No Active Plan"}
            </p>


  {/* Show "Active" only if subscription is not free */}
  {subscriptionState?.status === "active" && subscriptionState?.plan !== "free" && (
    <span className="px-3 py-1 text-[14px] font-semibold text-[#0F9D58] border border-[#0F9D58] rounded-sm">
      Active
    </span>
  )}</div>
          )}
          {subscriptionState?.status == "pending" ? (
            <SkeletonTheme baseColor="#BDD0DB" highlightColor="#fff">
              <Skeleton width={"129px"} height={"39px"} />
            </SkeletonTheme>
          ) : (
            <p className="mt-4">
              {" "}
              <span
                className="text-[#212121] text-[16px] lg:text-[30px] mt-10"
                style={{ fontWeight: 600 }}
              >
                {formatMoney(
                  subscriptionState?.costPerMonth as unknown as number
                )
                  ? formatMoney(
                      subscriptionState?.costPerMonth as unknown as number
                    )
                  : 0}
              </span>
             {" "} per month
            </p>
          )}
        </div>

        <div className="flex flex-row justify-between items-center border-t pt-6  px-[12px] md:px-[30px]">
          <SubscriptionHistoryWidget subscriptionData={subscriptionState} />
          {subscriptionState?.status == "pending" ? (
            <SkeletonTheme baseColor="#EDF2F5" highlightColor="#fff">
              <Skeleton width={"300%"} height={"9px"} />
            </SkeletonTheme>
          ) : (
            <button
              className="border border-[#044E97] rounded-[4px] py-[8px] px-[13px] md:py-[10px] md:px-[34px] text-[#044E97] text-[16px] whitespace-nowrap"
              style={{ fontWeight: 600 }}
              onClick={() => setShowModal(true)} // Open modal on click
            >
              {subscriptionState?.status === "active" ? (
                <p>Change Plan</p>
              ) : (
                <p>Choose Plan</p>
              )}
            </button>
          )}
        </div>
      </div>

      {/* Mobile */}
      <div className="w-full bg-blue-100 border-[#E0EEFE] border-4 rounded-xl shadow-sm md:hidden">
      {/* Plan Title */} 
      <p className="text-[16px] font-semibold text-[#212121] capitalize bg-[#E0EEFE] p-2">
        {subscriptionState?.plan || "Basic Plan"}
      </p>

      {/* Subscription Usage */}
      <div className="rounded-xl bg-white ">      
        <div className="mt-2 flex justify-between items-center pt-4 px-4 pb-2">
        <p className="text-[16px] font-medium text-[#212121]">Subscription usage</p>

        {subscriptionState?.status === Active && (
  <button 
    className="text-[14px] text-red-500 bg-[#FEF3F2] px-2 p-1 rounded-md"  
    onClick={() => setShowPrompt(true)}
  >
    Cancel plan
  </button>
)}
      </div>
      <p className="text-[14px] text-gray-600 px-4 border-b pb-2">Expires in {expirationDate}</p>

  {/* Usage Indicator */}
 {/* Usage Indicator */}
<div className="flex flex-col items-center mb-2  px-4">
  {subscriptionState?.status === "pending" ? (
    <SkeletonTheme baseColor="#EDF2F5" highlightColor="#fff">
      <div className="relative w-20 h-20">
        <Skeleton circle width={80} height={80} />
      </div>
    </SkeletonTheme>
  ) : (
    <div className="relative w-32 h-16 p-4">
      {subscriptionState?.daysTotal && subscriptionState?.daysUsed !== undefined ? (
        <UsageIndicator
        percentage={parseFloat(((subscriptionState.daysUsed / subscriptionState.daysTotal) * 100).toFixed(0))}
        />
      ) : (
        <p className="text-[14px] font-semibold">No Data</p>
      )}
    </div>
  )}
</div>
      {/* Alert Message */}
      <p className="text-[16px] font-semibold text-[#212121] pt-10  px-4">
        You have almost reached your limit
      </p>
      <p className="text-[14px] text-gray-500 px-4">
        You have used % of your allocated quota. Top up or upgrade your plan.
      </p>

      {/* Actions */}
      <div className="flex justify-between mt-4 gap-2  p-4 border-t">
        <button className="flex-1 border border-gray-300 text-gray-700 bg-white py-2 rounded-md">
          Buy again
        </button>
        <button  onClick={() => setShowModal(true)}  className="flex-1 border border-gray-300 text-gray-700  bg-white py-2 rounded-md">
          Change plan
        </button>
      </div>
      </div>
    </div>
      

      {/* Render the SubscriptionModal */}
      {showModal && (
        <SubscriptionPage
          close={() => setShowModal(false)} // Close modal
        />
      )}
    </div>
    </>
  );
};

export default SubscriptionPlan;
